import * as Yup from "yup";

// national code validation
export const validateIranianNationalId = (id: string): boolean => {
  // Ensure that the ID has exactly 10 digits
  if (!/^\d{10}$/.test(id)) return false;

  // Calculate the checksum based on the first 9 digits of the ID
  let check = parseInt(id[9], 10);
  let sum =
    Array(9)
      .fill(0)
      .map((_, i) => parseInt(id[i], 10) * (10 - i))
      .reduce((x, y) => x + y) % 11;

  // Validate the checksum. If sum is less than 2, the last digit should be equal to sum.
  // Otherwise, the sum of the last digit and sum should be 11.
  return (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
};

export const userValidationSchema = Yup.object().shape({
  nationalCode: Yup.string()
    .trim("کد ملی نباید فقط از فاصله تشکیل شده باشد")
    .matches(/^[0-9]+$/, " لطفا فقط عدد وارد کنید")
    .matches(/^\d{10}$/, "کد ملی باید دقیقاً 10 رقم باشد") // Ensure exactly 10 digits
    .test("iran-national-id", "کد ملی معتبر نیست", (value) =>
      validateIranianNationalId(value || "")
    ) // Ensure valid Iranian National ID structure
    .required("فیلد را پر کنید"), // Ensure the field is provided
});
